import { Box } from '@mui/material'
import { useSelector } from 'react-redux'

import UseTranslation from '../../../../hooks/UseTranslation'
import useAttachmentGroup from '../../../../hooks/useAttachmentGroup'
import { selectAttachment } from '../../../../redux/features/attachment/attachmentSlice'
import OfoqAttachmentInput from '../../../../components/Forms/OfoqAttachmentInput'
import { attachmentResetAlertHandler } from '../../../../redux/features/attachment/attachmentThunk'
import LoaderWithErrorHandler from '../../../../components/PageHelpers/LoaderWithErrorHandler'

const SelectionModelAttachment = ({
  handleAttachmentGroupIdChange,
  handleAttachmentFilesChange,
  notification,
}) => {
  const { translations } = UseTranslation()

  const {
    handleAddFile, handleRemoveFile, getGroupId,
  } = useAttachmentGroup({
    tag: 'notification-inbox',
    groupId: notification?.attachments?.attachmentGroupId,
  })
  const attachmentStore = useSelector(selectAttachment)

  const onFileSelected = async (file) => {
    const attachment = await handleAddFile(file)
    handleAttachmentGroupIdChange(notification?.id, getGroupId())
    return attachment
  }

  const onDeleteFile = async (file) => {
    const res = await handleRemoveFile(file)
    return res
  }

  return (
    <Box>
      <OfoqAttachmentInput
        name={translations?.Attachments}
        defaultValue={notification?.attachmentFiles}
        onFileAdd={onFileSelected}
        onFileRemove={onDeleteFile}
        onFilesChange={(files) => handleAttachmentFilesChange(notification?.id, files)}
      />

      <LoaderWithErrorHandler
        resetAlertHandler={attachmentResetAlertHandler}
        store={attachmentStore}
      />
    </Box>
  )
}
export default SelectionModelAttachment
